// extracted by mini-css-extract-plugin
module.exports = {"navLink":"A7","headerButton":"A8","navLinkWhileSearching":"A9","borderLink":"A-"};